import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from '../../../../components/Select';

import { fetchAllClientInformationData } from '../../../../services/redux/employee/clientInformation/actions';
import { fetchStates } from '../../../../services/redux/commonData/actions';
import {
    fetchTrustByClient,
    clearTrustsList
} from '../../../../services/redux/employee/trust/actions';
import {
    fetchPortfolioByTrust,
    clearPortfoliosList
} from '../../../../services/redux/employee/portfolio/actions';
import {
    fetchClassesByPortfolio,
    clearClassesList
} from '../../../../services/redux/employee/classes/actions';
import {
    fetchProspectusByClient,
    clearProspectusesList
} from '../../../../services/redux/employee/prospectus/actions';

class SelectFundPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selection: {
                stateId: '',
                clientId: '',
                trustId: '',
                portfolioId: '',
                classId: '',
                prospectusId: ''
            }
        };
    }

    componentDidMount() {
        let { fetchAllClientInformationData, fetchStates } = this.props;
        fetchAllClientInformationData();
        fetchStates();
    }

    componentWillUnmount() {
        let {
            clearTrustsList,
            clearProspectusesList,
            clearPortfoliosList,
            clearClassesList
        } = this.props;
        clearTrustsList();
        clearProspectusesList();
        clearPortfoliosList();
        clearClassesList();
    }

    emitSelection(selection) {
        let { onSelectionChange } = this.props;
        this.setState({ selection });
        onSelectionChange(selection);
    }

    handleStateChange = (name, value) => {
        let selection = { ...this.state.selection };
        selection.stateId = value !== null ? value.stateId : '';
        this.emitSelection(selection);
    };

    handleSelectChange = (name, value) => {
        let {
            fetchTrustByClient,
            fetchPortfolioByTrust,
            fetchClassesByPortfolio,
            fetchProspectusByClient,
            clearTrustsList,
            clearPortfoliosList,
            clearClassesList,
            clearProspectusesList
        } = this.props;

        let selection = { ...this.state.selection };
        selection[name] = value !== null ? value[name] : '';

        if (name === 'clientId') {
            clearTrustsList();
            clearProspectusesList();
            clearPortfoliosList();
            clearClassesList();
            selection.trustId = '';
            selection.prospectusId = '';
            selection.portfolioId = '';
            selection.classId = '';
            if (value !== null) {
                fetchTrustByClient(value[name]);
                fetchProspectusByClient(value[name]);
            }
        } else if (name === 'trustId') {
            clearPortfoliosList();
            clearClassesList();
            selection.portfolioId = '';
            selection.classId = '';
            if (value !== null) {
                fetchPortfolioByTrust(value[name]);
            }
        } else if (name === 'portfolioId') {
            clearClassesList();
            selection.classId = '';
            if (value !== null) {
                fetchClassesByPortfolio(value[name]);
            }
        }

        this.emitSelection(selection);
    };

    render() {
        let {
            clientInformation,
            trust,
            portfolio,
            classes,
            prospectus,
            commonData
        } = this.props;
        let { selection } = this.state;
        let eFilingStates = (commonData.states || []).filter(
            s => s.isElectronicFiling
        );
        return (
            <div>
                <div className="row">
                    <div className="col-md-12 mb">
                        <Select
                            name="stateId"
                            placeholder="Choose a State"
                            labelKey="name"
                            valueKey="stateId"
                            selectedValue={selection.stateId}
                            onChange={this.handleStateChange}
                            options={eFilingStates}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 mb">
                        <Select
                            name="clientId"
                            placeholder="Choose a Client"
                            labelKey="name"
                            valueKey="clientId"
                            selectedValue={selection.clientId}
                            onChange={this.handleSelectChange}
                            options={clientInformation.clients}
                        />
                    </div>
                </div>
                {selection.clientId && (
                    <div className="row">
                        <div className="col-md-6 mb">
                            <Select
                                name="trustId"
                                placeholder="Choose a Trust"
                                labelKey="name"
                                valueKey="trustId"
                                selectedValue={selection.trustId}
                                onChange={this.handleSelectChange}
                                options={trust.trusts}
                                disabled={selection.prospectusId}
                            />
                        </div>
                        <div className="col-md-6 mb">
                            <Select
                                name="prospectusId"
                                placeholder="or choose a Prospectus"
                                labelKey="name"
                                valueKey="prospectusId"
                                selectedValue={selection.prospectusId}
                                onChange={this.handleSelectChange}
                                options={prospectus.prospectusList}
                                disabled={selection.trustId}
                            />
                        </div>
                    </div>
                )}
                {selection.trustId && (
                    <div className="row">
                        <div className="col-md-12 mb">
                            <Select
                                name="portfolioId"
                                placeholder="Choose a Portfolio"
                                labelKey="name"
                                valueKey="portfolioId"
                                selectedValue={selection.portfolioId}
                                onChange={this.handleSelectChange}
                                options={portfolio.portfolios}
                            />
                        </div>
                    </div>
                )}
                {selection.portfolioId && (
                    <div className="row">
                        <div className="col-md-12 mb">
                            <Select
                                name="classId"
                                placeholder="Choose a Class"
                                labelKey="name"
                                valueKey="classId"
                                selectedValue={selection.classId}
                                onChange={this.handleSelectChange}
                                options={classes.classes}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    clientInformation: state.employee.clientInformation,
    trust: state.employee.trust,
    portfolio: state.employee.portfolio,
    classes: state.employee.classes,
    prospectus: state.employee.prospectus,
    commonData: state.commonData
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchAllClientInformationData,
            fetchStates,
            fetchTrustByClient,
            fetchPortfolioByTrust,
            fetchClassesByPortfolio,
            fetchProspectusByClient,
            clearTrustsList,
            clearPortfoliosList,
            clearClassesList,
            clearProspectusesList
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(SelectFundPanel));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ElectronicFilings/SelectFundPanel.js